"use client";

import React, { useState } from "react";
import { OrderListItem } from "../services/order-service";

interface OrderCancelModalProps {
  open ?: boolean;
  order: OrderListItem | null;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

const OrderCancelModal: React.FC<OrderCancelModalProps> = ({ order, onClose, onConfirm }) => {
  const [reason, setReason] = useState("");

  if (!order) return null;

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl w-[450px] max-w-[95vw] p-6 shadow-2xl">
        <h3 className="text-lg font-semibold mb-4 text-center text-red-600">
          Huỷ đơn hàng
        </h3>

        <div className="text-sm space-y-3">
          <p><b>Mã đơn:</b> {order.code ?? `OD-${order.id}`}</p>
          <p><b>Khách hàng:</b> {order.customer?.name ?? "—"}</p>
          <p><b>Tổng tiền:</b> {Number(order.total_amount).toLocaleString("vi-VN")} ₫</p>

          <label className="block font-medium text-slate-600 mt-2">Lý do huỷ:</label>
          <textarea
            className="w-full border rounded px-3 py-2 h-24"
            placeholder="Nhập lý do huỷ đơn..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        <div className="mt-5 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 border rounded">
            Trở lại
          </button>
          <button
            onClick={() => onConfirm(reason)}
            className="px-5 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Xác nhận huỷ
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderCancelModal;
